// extracted by mini-css-extract-plugin
module.exports = {"Container":"LabeledDiv_Container__2Ap8R","Div":"LabeledDiv_Div__1QYHn"};